'use client';
import styled from 'styled-components';

export const StyledOnboardingInterstitial = styled.main`
  text-align: center;
  max-width: 360px;
  margin: 0 auto;
`;

export const ImageContainer = styled.div`
  margin-bottom: ${props => props.theme.spacing(4)};
`;

export const Headline = styled.div`
  ${props => props.theme.typography.heading4}
  margin-bottom:${props => props.theme.spacing(1)};
`;

export const Subheadline = styled.div`
  ${props => props.theme.typography.body}
  margin-bottom:${props => props.theme.spacing(5)};
  a {
    color: ${props => props.theme.colors.hero.blueberry};
  }
`;

export const Body = styled.div`
  ${props => props.theme.typography.heading5}
  background-color:${props => props.theme.colors.background.lightest};
  border-radius: ${props => props.theme.spacing(8)};
  padding: ${props => props.theme.spacing(7, 8, 6)};
`;
